"use client"

import { Button } from "@/components/ui/button"
import type { PersistedRsvpStatus } from "@/lib/events/types"

const RSVP_OPTIONS = [
  { status: "going" as const, label: "Going" },
  { status: "maybe" as const, label: "Maybe" },
  { status: "declined" as const, label: "Not going" },
] as const

type Props = {
  value: PersistedRsvpStatus | null | undefined
  disabled?: boolean
  onPick: (status: PersistedRsvpStatus) => void
}

export function EventRsvpChoiceButtons({
  value,
  disabled,
  onPick,
}: Props) {
  return (
    <div className="flex flex-wrap gap-2">
      {RSVP_OPTIONS.map(({ status, label }) => (
        <Button
          key={status}
          type="button"
          variant={value === status ? "secondary" : "outline"}
          size="sm"
          className="rounded-full"
          disabled={disabled}
          onClick={() => void onPick(status)}
        >
          {label}
        </Button>
      ))}
    </div>
  )
}
